import React from 'react'
import classes from './InfoBox.module.css'

const InfoBox = (props)=>{
    return(
        
        <div className={classes.container}>
            <center>
        <div className={classes.box}>
            <div className={classes.items1}>
              <p className={classes.heading}>15000+</p>
              <p   className={classes.subHeading} >BUY BOOK BY CHAPTER</p>
            <p className={classes.content}>Books and Chapters by various publications  </p>

            </div>
            <div  className={classes.items}>
            <p className={classes.heading}>140+</p>
            <p   className={classes.subHeading} >COLLEGES</p>
            <p className={classes.content}>Students from 140+ colleges </p>
            </div>
            <div  className={classes.items}>
            <p className={classes.heading}>20+</p>
            <p   className={classes.subHeading} >PROGRAM</p>
            <p className={classes.content}> Study Material based University guidelines </p>
            </div>

        </div>
        </center>
        </div>
       
    )
}
export default InfoBox;